import React from 'react';

import ButtonTakeScreenshot from './ButtonTakeScreenshot';
import ButtonCopyToClipboard from './ButtonCopyToClipboard';

const VirtualSessionToolbar: React.FC = () => (
  <div
    className="w-24 min-w-24 mt-2 ml-2"
    data-qa="live-session-toolbar"
  >
    <div
      className="bg-white rounded filter drop-shadow-md"
      role="menu"
    >
      <ButtonTakeScreenshot role="menuitem" />
      <ButtonCopyToClipboard role="menuitem" />
    </div>
  </div>
);

VirtualSessionToolbar.displayName = 'VirtualSessionToolbar';

export default VirtualSessionToolbar;
